import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { WebAnalyticsShellComponent } from './pages/web-analytics-shell/web-analytics-shell.component';
import { WebAnalyticsUsersComponent } from './pages/web-analytics-users/web-analytics-users.component';
import { WebAnalyticsUserDetailComponent } from './pages/web-analytics-user-detail/web-analytics-user-detail.component';

export const routes: Routes = [
  {
    path: '',
    component: WebAnalyticsShellComponent,
    children: [
      { path: '', component: DashboardComponent },
      { path: 'users', component: WebAnalyticsUsersComponent },
      { path: 'users/:username', component: WebAnalyticsUserDetailComponent },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
